<div class="overLayDiv active"></div>
<div id="rightSideBar">
    <div style="width: 85% !important;" class="rightSidePanel active">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2>{{ "errors_warnings_employee_list" | translate }}</h2>
            </div>            
            <div class="panel-left-btn">
                <button type="button" class="btn eod-btn-outline-warning mr-2" (click)="fnOnExportClick()">
                    {{ "label_export" | translate }}
                </button>
                <button type="button" class="btn eod-btn-outline-warning" (click)="fnClosePanel()">
                    {{ "close" | translate }}
                </button>
            </div>
        </header>
        <div class="eod-panel-body">
            <div class="block heightCalc-5">
                <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 no-padding-right-left heightCalc-12">
                    <!----------------------Start Grid--------------------------->
                    <app-grid [columns]="gridColumnDefs" [data]="gridData" [gridConfigItems]="gridConfigItems"></app-grid>
                    <!----------------------End Grid--------------------------->
                </div>
            </div>
        </div>

    </div>
</div>